import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ChannelsBanner from '../../../../../components/ChannelsBanner';
import { Swimlane } from '../../../../../components/Swimlane/Swimlane';
import { DispatchType, RootState } from '../../../../../interfaces';
import { useSectionItems } from '../../../../../queries/ats/layout/queries';
import { Layout } from '../../../../../queries/ats/layout/types';
import { useChannels } from '../../../../../queries/channels/queries';
import { classes } from '../../../../../utils/commonUtils';
import { getCatchupEnabledChannels } from '../../../../../utils/programArchiveUtils';
import { showLoginModal } from '../../../../app/actions';
import css from './SectionUserChannelsCatchup.module.scss';

interface SectionUserChannelsCatchupProps {
  view: Layout.SectionView;
  pageStyle: 'grid' | 'swimlane';
  className?: string;
}

export function SectionUserChannelsCatchup({ view, pageStyle, className }: SectionUserChannelsCatchupProps) {
  const auth = useSelector((state: RootState) => state.authReducer);
  const { data: channels } = useChannels();
  const dispatch: DispatchType = useDispatch();

  const { data: items } = useSectionItems({ link: view.link });

  if (!channels) {
    return null;
  }
  const catchupChannels = getCatchupEnabledChannels([...channels]);
  return (
    <div className={className}>
      <ChannelsBanner
        overrideTitle={view.label}
        sectionItems={items}
        onlyInSubscription={true}
        channels={catchupChannels}
        authReducer={auth}
        isProgramArchive={true}
        showLoginModal={() => dispatch(showLoginModal)}
        isGrid={pageStyle === 'grid'}
        isUnmanaged
      />
    </div>
  );
}

function SectionUserChannelsCatchupSkeleton({ view, pageStyle, className }: SectionUserChannelsCatchupProps) {
  if (pageStyle === 'grid') {
    return null;
  }

  return (
    <div className={classes(css.skeleton, className)}>
      <Swimlane>
        <Swimlane.Header>
          <Swimlane.Title>{view.label}</Swimlane.Title>
          <Swimlane.Buttons />
        </Swimlane.Header>
        <Swimlane.Slider>
          {Array.from({ length: 10 }).map((_, index) => (
            <div key={index} className={css.box} />
          ))}
        </Swimlane.Slider>
      </Swimlane>
    </div>
  );
}

SectionUserChannelsCatchup.Skeleton = SectionUserChannelsCatchupSkeleton;
